









import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import ReferenceGeneratorModal from './ReferenceGeneratorModal.vue'
import { ActiveEnvironmentName } from '../../constants/environment';

@Component({ components: { ReferenceGeneratorModal } })
export default class ReferenceGenerator extends Vue
{
    get isNotProd() {
        return ActiveEnvironmentName !== 'production';
    }
}
